export const TAB_IDS = {
  COMMITMENTS: 'commitments',
  TENDERS: 'tenders',
  SCORECARD: 'scorecard',
  ABOUT: 'about'
};

export const COMMITTED_CAPACITY_PENDO_ROOT = "Carrier Portal > Committed Capacity > Commitments >";
export const COMMITTED_CAPACITY_PENDO_LANES_LIST = `${COMMITTED_CAPACITY_PENDO_ROOT} Committed Lanes List >`;


//excludes Hawaii as we don't run lanes there
const states = [
  { id: "AL", label: "Alabama - AL", value: "Alabama - AL" },
  { id: "AK", label: "Alaska - AK", value: "Alaska - AK"},
  { id: "AZ", label: "Arizona - AZ", value: "Arizona - AZ" },
  { id: "AR", label: "Arkansas - AR", value: "Arkansas - AR" },
  { id: "CA", label: "California - CA", value: "California - CA" },
  { id: "CO", label: "Colorado - CO", value: "Colorado - CO" },
  { id: "CT", label: "Connecticut - CT", value: "Connecticut - CT" },
  { id: "DE", label: "Delaware - DE", value: "Delaware - DE" },
  { id: "FL", label: "Florida - FL", value: "Florida - FL" },
  { id: "GA", label: "Georgia - GA", value: "Georgia - GA" },
  { id: "ID", label: "Idaho - ID", value: "Idaho - ID" },
  { id: "IL", label: "Illinois - IL", value: "Illinois - IL" },
  { id: "IN", label: "Indiana - IN", value: "Indiana - IN" },
  { id: "IA", label: "Iowa - IA", value: "Iowa - IA" },
  { id: "KS", label: "Kansas - KS", value: "Kansas - KS" },
  { id: "KY", label: "Kentucky - KY", value: "Kentucky - KY" },
  { id: "LA", label: "Louisiana - LA", value: "Louisiana - LA" },
  { id: "ME", label: "Maine - ME", value: "Maine - ME" },
  { id: "MD", label: "Maryland - MD", value: "Maryland - MD" },
  { id: "MA", label: "Massachusetts - MA", value: "Massachusetts - MA" },
  { id: "MI", label: "Michigan - MI", value: "Michigan - MI" },
  { id: "MN", label: "Minnesota - MN", value: "Minnesota - MN" },
  { id: "MS", label: "Mississippi - MS", value: "Mississippi - MS" },
  { id: "MO", label: "Missouri - MO", value: "Missouri - MO" },
  { id: "MT", label: "Montana - MT", value: "Montana - MT" },
  { id: "NE", label: "Nebraska - NE", value: "Nebraska - NE" },
  { id: "NV", label: "Nevada - NV", value: "Nevada - NV" },
  { id: "NH", label: "New Hampshire - NH", value: "New Hampshire - NH" },
  { id: "NJ", label: "New Jersey - NJ", value: "New Jersey - NJ" },
  { id: "NM", label: "New Mexico - NM", value: "New Mexico - NM" },
  { id: "NY", label: "New York - NY", value: "New York - NY" },
  { id: "NC", label: "North Carolina - NC", value: "North Carolina - NC" },
  { id: "ND", label: "North Dakota - ND", value: "North Dakota - ND" },
  { id: "OH", label: "Ohio - OH", value: "Ohio - OH" },
  { id: "OK", label: "Oklahoma - OK", value: "Oklahoma - OK" },
  { id: "OR", label: "Oregon - OR", value: "Oregon - OR" },
  { id: "PA", label: "Pennsylvania - PA", value: "Pennsylvania - PA" },
  { id: "RI", label: "Rhode Island - RI", value: "Rhode Island - RI" },
  { id: "SC", label: "South Carolina - SC", value: "South Carolina - SC" },
  { id: "SD", label: "South Dakota - SD", value: "South Dakota - SD" },
  { id: "TN", label: "Tennessee - TN", value: "Tennessee - TN" },
  { id: "TX", label: "Texas - TX", value: "Texas - TX" },
  { id: "UT", label: "Utah - UT", value: "Utah - UT" },
  { id: "VT", label: "Vermont - VT", value: "Vermont - VT" },
  { id: "VA", label: "Virginia - VA", value: "Virginia - VA" },
  { id: "WA", label: "Washington - WA", value: "Washington - WA" },
  { id: "WV", label: "West Virginia - WV", value: "West Virginia - WV" },
  { id: "WI", label: "Wisconsin - WI", value: "Wisconsin - WI" }
]

export const allStates = [
  ...states,
  { id: "CANADA", label: "Canada", value: "Canada" }
]

export const canadaStates = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
]

export const CC_EQUIPMENT_TYPE_MAP : { [key: string]: string } = {
  'Van': "Van",
  'Van Only': "Van",
  'Reefer Only': "Reefer",
  'Flatbed': "Flatbed",
  'Flatbed Only': "Flatbed",
  'Van or Reefer': "Van, Reefer",
  'Van or Flatbed': "Van, Flatbed",
  'Van / Reefer / Flatbed': "Van, Reefer, Flatbed",
  'Container': "Container",
  'Power Only': "Power",
  'Flatbed or Conestoga': "Flatbed, Conestoga",
  'Vented Van': "Vented Van",
  "Sprinter/Cargo Van": "Sprinter/Cargo Van",
  "Straight Box Truck": "Straight Box Truck"
}
